export default function Shimmer(){
    return(
        <>
        <div className="mt-20 flex flex-wrap w-[80%] mx-auto gap-5">

            <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
              <div className="w-[280px] mb-2">
                <div className="w-70 h-45 rounded-xl bg-gray-400"></div>
                <div className="w-[95%] mx-auto">
                    <div className="w-full h-6 bg-gray-400"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                    <div className="w-full h-6 bg-gray-400 mt-2"></div>
                </div>
            </div>
        </div>
        </>
    )
}